import { Outlet } from 'react-router-dom';

/**
 * AuthLayout — minimal scaffolding (refactored later in Fase 5
 * when SuperPageTemplate / branded hero exist).
 * For now provides the canvas; the LoginView paints itself.
 */
export function AuthLayout() {
  return (
    <div className="min-h-screen bg-bg text-text">
      <Outlet />
    </div>
  );
}
